<template>
  <div>
    <b-row>
      <b-col v-if="$can('Save', 'AllFOP')" class="mb-1">
        <b-button v-b-modal.modal-paymentoption variant="primary">
          <feather-icon icon="PlusIcon" class="mr-25" />
          <span>Add Payment Option</span>
        </b-button>
      </b-col>
    </b-row>
    <b-card title="Payment Options">
      <b-row>
        <b-col md="3">
          <b-form-group>
            <b-form-input
              v-model="filter"
              placeholder="Search"
              type="text"
              class="d-inline-block mr-1"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table
            striped
            :items="paymentOptions"
            :fields="fields"
            :filter="filter"
            :per-page="perPage"
            :current-page="currentPage"
            caption-top
            :responsive="true"
          >
            <template v-slot:cell(Id)="paymentOptions">
              {{ paymentOptions.item.paymentOptionId }}
            </template>
            <template v-slot:cell(logo)="paymentOptions">
              <b-avatar :src="paymentOptions.item.imageUrl" />
            </template>

            <template v-slot:cell(status)="paymentOptions">
              <b-badge
                v-if="paymentOptions.item.status === 2"
                pill
                variant="success"
              >
                Active
              </b-badge>
              <b-badge
                v-else-if="paymentOptions.item.status === 1"
                pill
                variant="danger"
              >
                InActive
              </b-badge>
            </template>
            <template
              v-slot:cell(actions)="paymentOptions"
              v-if="
                $can('Update', 'AllFOP') ||
                $can('Delete', 'AllFOP') ||
                $can('Delete', 'AllFOP')
              "
            >
              <b-row>
                <b-dropdown
                  variant="link"
                  no-caret
                  :right="$store.state.appConfig.isRTL"
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                  </template>
                  <b-dropdown-item
                    v-if="$can('Update', 'AllFOP')"
                    href="#"
                    variant="success"
                    @click="editFop(paymentOptions.item.id)"
                  >
                    <feather-icon class="yellow-icon" icon="EditIcon" />
                    <span class="align-middle ml-50">Edit</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="$can('Delete', 'AllFOP')"
                    href="#"
                    variant="danger"
                    @click="
                      DeletePaymentOption(
                        paymentOptions.item.id,
                        paymentOptions.item.name
                      )
                    "
                  >
                    <feather-icon class="blue-icon" icon="Trash2Icon" />
                    <span class="align-middle ml-50">Delete</span>
                  </b-dropdown-item>
                </b-dropdown>
              </b-row>
            </template>
          </b-table>
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Showing 1 to &nbsp; </span>
              <b-form-select
                id="per-page-select"
                v-model="perPage"
                :options="[5, 10, 15, 20, { value: 100, text: 'Show all' }]"
                size="sm"
              ></b-form-select>
              <span class="text-nowrap">
                &nbsp; of {{ paymentOptions.length }} entries
              </span>
            </div>
            <div>
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
              />
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-modal
          id="modal-paymentoption"
          ref="modal"
          hide-footer
          title="Add New Payment Option"
          size="lg"
        >
          <validation-observer ref="simpleRules">
            <form ref="form" @submit.stop.prevent="validationEditForm">
              <b-row>
                <b-col md="6">
                  <b-form-group label="Name" label-for="name">
                    <validation-provider
                      #default="{ errors }"
                      name="name"
                      rules="required"
                    >
                      <b-form-input
                        v-on:paste="
                          (e) => {
                            e.preventDefault();
                            return false;
                          }
                        "
                        v-on:keypress="isLetter($event)"
                        id="name-input"
                        v-model="newPaymentOption.name"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Code" label-for="code">
                    <validation-provider
                      #default="{ errors }"
                      name="code"
                      rules="required"
                    >
                      <b-form-input
                        v-on:paste="
                          (e) => {
                            e.preventDefault();
                            return false;
                          }
                        "
                        id="code-input"
                        v-model="newPaymentOption.code"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Country" label-for="country">
                    <validation-provider
                      #default="{ errors }"
                      name="country"
                      rules="required"
                    >
                      <v-select
                        v-model="newPaymentOption.countryId"
                        :options="countryOptions"
                        @input="getByCountry"
                        label="text"
                        :state="errors.length > 0 ? false : null"
                      >
                        <template #option="option">
                          <span>{{ option.text }}</span>
                        </template>
                      </v-select>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Currency" label-for="currency">
                    <validation-provider
                      #default="{ errors }"
                      name="currency"
                      rules="required"
                    >
                      <b-form-select
                        id="currency-input"
                        v-model="newPaymentOption.currencyId"
                        :options="currencyOptions"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="Type" label-for="typeId">
                    <validation-provider
                      #default="{ errors }"
                      name="Select Type"
                      label-for="input-3"
                    >
                      <b-form-select
                        id="input-3"
                        v-model="newPaymentOption.typeId"
                        :options="paymentType"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="Provider" label-for="providerId">
                    <validation-provider
                      #default="{ errors }"
                      name="providerId"
                    >
                      <b-form-select
                        id="input-3"
                        v-model="newPaymentOption.providerId"
                        :options="providerOptions"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col md="4">
                  <b-form-group
                    label="Select Refund Path"
                    label-for="refundPath"
                  >
                    <validation-provider
                      name="Select Refund Path"
                      label-for="input-3"
                    >
                      <b-form-select
                        id="input-3"
                        v-model="newPaymentOption.refundPath"
                        :options="refundPathOptions"
                        @input="ChangePath"
                      />
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group
                    label="Maximum amount capacity"
                    label-for="maxAmountCap"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="maxAmountCapLimit"
                      rules="required"
                    >
                      <b-form-input
                        id="MaxAmountCap-input"
                        v-model.number="newPaymentOption.maxAmountCapLimit"
                        type="number"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group
                    label="Payment Options"
                    label-for="PaymentOptionEnum"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Select Payment Option Enum "
                      label-for="PaymentOptionEnum-3"
                    >
                      <b-form-select
                        id="input-3"
                        v-model="newPaymentOption.paymentOption"
                        :options="paymentOptionsEnum"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col v-if="isManualOptionSelected" md="4">
                  <b-form-group
                    label="Refund Manual Option "
                    label-for="RefundManualOption "
                  >
                    <validation-provider
                      name="Select Refund Manual Option "
                      label-for="input-3"
                    >
                      <b-form-select
                        id="input-3"
                        v-model="newPaymentOption.refundManualOption"
                        :options="refundManualOptions"
                      />
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Image" label-for="ImageURL">
                    <validation-provider
                      #default="{ errors }"
                      name="imageURL"
                      rules="required"
                    >
                      <b-form-file
                        id="file-default"
                        v-model="newPaymentOption.formFile"
                        :state="errors.length > 0 ? false : null"
                        accept="image/jpeg, image/png"
                      ></b-form-file>

                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group
                    label="Transaction Activity Check Hour"
                    label-for="transactionActivityCheckHour"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="maxAmountCap"
                      rules="required"
                    >
                      <b-form-input
                        id="MaxAmountCap-input"
                        v-model.number="
                          newPaymentOption.transactionActivityCheckHour
                        "
                        type="number"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col v-if="isAuthoEditBools" md="6">
                  <b-form-group
                    label="Send Auth Refund Massage"
                    label-for="sendAuthRefund"
                  >
                    <b-form-checkbox
                      id="sendAuthRefund-input"
                      v-model="newPaymentOption.sendAuthRefund"
                      @change="CheckAuthoEditRefund"
                    />
                  </b-form-group>
                </b-col>

                <b-col v-if="isAuthoEditBools" md="6">
                  <b-form-group
                    label="Consider Auth Refund As Confirmed"
                    label-for="considerAuthRefundAsConfirmed"
                  >
                    <b-form-checkbox
                      id="considerAuthRefundAsConfirmed-input"
                      v-model="newPaymentOption.considerAuthRefundAsConfirmed"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group
                    label="Allow Refund Confirmation Notification"
                    label-for="allowRefundConfirmationNotification"
                  >
                    <b-form-checkbox
                      id="allowRefundConfirmationNotification-input"
                      v-model="
                        newPaymentOption.allowRefundConfirmationNotification
                      "
                    />
                  </b-form-group>
                </b-col>

                <b-col md="10">
                  <b-form-group label="Description" label-for="description">
                    <b-form-textarea
                      v-on:keypress="isLetterandNumber($event)"
                      v-on:paste="
                        (e) => {
                          e.preventDefault();
                          return false;
                        }
                      "
                      id="description-input"
                      v-model="newPaymentOption.description"
                      rows="3"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="10">
                  <b-form-group label="Instruction" label-for="instruction">
                    <b-form-textarea
                      v-on:paste="
                        (e) => {
                          e.preventDefault();
                          return false;
                        }
                      "
                      v-on:keypress="isLetterandNumber($event)"
                      id="description-input"
                      v-model="newPaymentOption.instruction"
                      rows="3"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-button
                variant="primary"
                type="submit"
                @click.prevent="validationForm"
              >
                Save
              </b-button>
            </form>
          </validation-observer>
        </b-modal>
      </b-row>
      <b-row>
        <b-modal
          id="modal-edit-paymentoption"
          ref="modal"
          hide-footer
          title="Edit Payment Option"
          size="lg"
        >
          <validation-observer ref="simpleRules">
            <form ref="form" @submit.stop.prevent="validationEditForm">
              <b-row>
                <b-form-input v-model="editPaymentOption.id" hidden />

                <b-col md="6">
                  <b-form-group label="Name" label-for="name">
                    <validation-provider
                      #default="{ errors }"
                      name="name"
                      rules="required"
                    >
                      <b-form-input
                        id="name-input"
                        v-model="editPaymentOption.name"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Code" label-for="code">
                    <validation-provider
                      #default="{ errors }"
                      name="code"
                      rules="required"
                    >
                      <b-form-input
                        id="code-input"
                        v-model="editPaymentOption.code"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Country" label-for="country">
                    <validation-provider
                      #default="{ errors }"
                      name="country"
                      rules="required"
                    >
                      <b-form-select
                        id="country-input"
                        v-model="editPaymentOption.countryId"
                        :options="countryOptions"
                        @change="getByCountry"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group label="Currency" label-for="currency">
                    <validation-provider
                      #default="{ errors }"
                      name="currency"
                      rules="required"
                    >
                      <b-form-select
                        id="currency-input"
                        v-model="editPaymentOption.currencyId"
                        :options="currencyOptions"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="Type" label-for="typeId">
                    <validation-provider
                      #default="{ errors }"
                      name="Select Type"
                      label-for="input-3"
                    >
                      <b-form-select
                        id="input-3"
                        v-model="editPaymentOption.typeId"
                        :options="paymentType"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="Provider" label-for="providerId">
                    <validation-provider
                      #default="{ errors }"
                      name="providerId"
                    >
                      <b-form-select
                        id="input-3"
                        v-model="editPaymentOption.providerId"
                        :options="providerOptions"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group
                    label="Select Refund Path"
                    label-for="refundPath"
                  >
                    <b-form-select
                      id="input-3"
                      v-model="editPaymentOption.refundPath"
                      :options="refundPathOptions"
                      @change="ChangeEditPath"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group
                    label="Maximum amount capacity"
                    label-for="maxAmountCap"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="maxAmountCap"
                      rules="required"
                    >
                      <b-form-input
                        id="MaxAmountCap-input"
                        v-model.number="editPaymentOption.maxAmountCapLimit"
                        type="number"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group
                    label="Payment Options"
                    label-for="PaymentOptionEnum"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Select Payment Option Enum "
                      label-for="PaymentOptionEnum-3"
                    >
                      <b-form-select
                        id="input-3"
                        v-model="editPaymentOption.paymentOption"
                        :options="paymentOptionsEnum"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col v-if="isManualOptionEditSelected" md="4">
                  <b-form-group
                    label="Refund Manual Option "
                    label-for="RefundManualOption "
                  >
                    <validation-provider
                      name="Select Refund Manual Option "
                      label-for="input-3"
                    >
                      <b-form-select
                        id="input-3"
                        v-model="editPaymentOption.refundManualOption"
                        :options="refundManualOptions"
                      />
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Image" label-for="ImageURL">
                    <validation-provider #default="{ errors }" name="imageURL">
                      <b-form-file
                        id="file-default"
                        v-model="editPaymentOption.formFile"
                        :state="errors.length > 0 ? false : null"
                        accept="image/jpeg, image/png"
                      ></b-form-file>

                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group
                    label="Transaction Activity Check Hour"
                    label-for="transactionActivityCheckHour"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="maxAmountCap"
                      rules="required"
                    >
                      <b-form-input
                        id="MaxAmountCap-input"
                        v-model.number="
                          editPaymentOption.transactionActivityCheckHour
                        "
                        type="number"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col v-if="isAuthoEditBools" md="6">
                  <b-form-group
                    label="Send Auth Refund Massage"
                    label-for="sendAuthRefund"
                  >
                    <b-form-checkbox
                      id="sendAuthRefund-input"
                      v-model="editPaymentOption.sendAuthRefund"
                      @change="CheckAuthoEditRefund"
                    />
                  </b-form-group>
                </b-col>

                <b-col v-if="isAuthoEditBools" md="6">
                  <b-form-group
                    label="Consider Auth Refund As Confirmed"
                    label-for="considerAuthRefundAsConfirmed"
                  >
                    <b-form-checkbox
                      id="considerAuthRefundAsConfirmed-input"
                      v-model="editPaymentOption.considerAuthRefundAsConfirmed"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group
                    label="Allow Refund Confirmation Notification"
                    label-for="allowRefundConfirmationNotification"
                  >
                    <b-form-checkbox
                      id="allowRefundConfirmationNotification-input"
                      v-model="
                        editPaymentOption.allowRefundConfirmationNotification
                      "
                    />
                  </b-form-group>
                </b-col>

                <b-col md="10">
                  <b-form-group label="Description" label-for="description">
                    <b-form-textarea
                      v-on:keypress="isLetter($event)"
                      id="description-input"
                      v-model="editPaymentOption.description"
                      rows="3"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="10">
                  <b-form-group label="Instruction" label-for="instruction">
                    <b-form-textarea
                      v-on:keypress="isLetterandNumber($event)"
                      id="description-input"
                      v-model="editPaymentOption.instruction"
                      rows="3"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-button
                variant="primary"
                type="submit"
                @click.prevent="validationEditForm"
              >
                Save
              </b-button>
            </form>
          </validation-observer>
        </b-modal>
      </b-row>
      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
  </div>
</template>
<script>
import {
  BRow,
  BCol,
  BFormInput,
  BTable,
  BPagination,
  BAvatar,
  BBadge,
  BButton,
  BFormGroup,
  BFormTextarea,
  BFormSelect,
  BLink,
  BCard,
  BOverlay,
  BDropdownItem,
  BDropdown,
  BFormCheckbox,
  BFormFile,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import vSelect from "vue-select";
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BTable,
    BPagination,
    BAvatar,
    BBadge,
    BButton,
    BFormGroup,
    BFormTextarea,
    BFormSelect,
    BLink,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BOverlay,
    BDropdownItem,
    BDropdown,
    BFormCheckbox,
    BFormFile,
    vSelect,
  },
  data() {
    return {
      required,
      perPage: 10,
      boolValue: null,
      isManualOptionSelected: false,
      isManualOptionEditSelected: false,
      isAuthoEditBools: true,
      isAuthoBools: true,
      isLoading: false,
      fields: [
        "Logo",
        "Id",
        "name",
        "code",
        "provider",
        "type",
        "country",
        "currency",
        "Status",
        "Actions",
      ],
      currencyOptions: [{ value: null, text: "--select a Currency--" }],
      countryOptions: [],
      paymentOptions: [],
      filter: "",
      currentPage: 1,
      newPaymentOption: {
        name: "",
        code: "",
        countryId: "",
        currencyId: "",
        providerId: 1,
        typeId: 1,
        refundPath: 1,
        sendAuthRefund: false,
        considerAuthRefundAsConfirmed: false,
        allowRefundConfirmationNotification: false,
        refundManualOption: 1,
        paymentOption: 0,
        description: "",
        formFile: null,
        maxAmountCapLimit: "",
        transactionActivityCheckHour: "",
        instruction: "",
      },
      paymentType: [],
      providerOptions: [],
      editPaymentOption: {
        id: "",
        name: "",
        code: "",
        countryId: null,
        currencyId: "",
        providerId: null,
        typeId: null,
        description: "",
        refundPath: 1,
        sendAuthRefund: false,
        considerAuthRefundAsConfirmed: false,
        allowRefundConfirmationNotification: false,
        refundManualOption: 1,
        paymentOption: null,
        formFile: null,
        maxAmountCapLimit: "",
        transactionActivityCheckHour: 0,
        instruction: "",
      },
      refundManualOptions: [
        { text: "Direct Process", value: 1 },
        { text: "Confirmation Needed", value: 2 },
      ],
      paymentOptionsEnum: [
        { text: "Default", value: 0 },
        { text: "CBEBranch", value: 1 },
        { text: "CBEBirr", value: 2 },
        { text: "Amole", value: 3 },
        { text: "PSS", value: 4 },
        { text: "United", value: 5 },
        { text: "Abyssinia", value: 6 },
        { text: "CBEMobile", value: 7 },
        { text: "Coop", value: 8 },
        { text: "Telebirr", value: 9 },
        { text: "CoopPayBank", value: 10 },
        { text: "TeleBirrRedirect", value: 11 },
        { text: "Nib", value: 12 },
        { text: "Lion", value: 13 },
        { text: "Wegagen", value: 14 },
        { text: "SehayMobile", value: 15 },
        { text: "Shebelle", value: 16 },
        { text: "Zemen", value: 17 },
        { text: "ZemenOTP", value: 18 },
        { text: "Awash", value: 19 },
        { text: "Dashen", value: 20 },
        { text: "Abay", value: 21 },
        { text: "BNPL", value: 22 },
        { text: "COOPPayEbirrMobile", value: 23 },
        { text: "Berhan", value: 24 },
        { text: "Mpesa", value: 25 },
        { text: "Amhara", value: 26 },
        { text: "Hijra", value: 27 },
        { text: "Oromia", value: 28 },
        { text: "CBEIB", value: 29 },
        { text: "Zamzam", value: 30 },
        { text: "Visa", value: 31 },
        { text: "MasterCard", value: 32 },
        { text: "AmericanExpress", value: 33 },
        { text: "DinersClub", value: 34 },
        { text: "JCB", value: 35 },
        { text: "Discover", value: 36 },
        { text: "Maestro", value: 37 },
        { text: "UnionPay", value: 38 },
        { text: "GooglePay", value: 40 },
        { text: "SamsungPay", value: 41 },
        { text: "PayPal", value: 42 },
        { text: "AliPay", value: 43 },
        { text: "WeChatPay", value: 44 },
        { text: "UnknowFOP", value: 45 },
        { text: "EtSwitch", value: 46 },
        { text: "Gadaa", value: 47 },
        { text: "Bunna", value: 48 },
        { text: "Albaraka", value: 49 },
        { text: "EcoBankCameroon", value: 50 },
        { text: "Chapa", value: 51 },
        { text: "QuantumOromia", value: 52 },
        { text: "EcobankIvoryCoast", value: 53 },
        { text: "EcoBankSenegal", value: 54 },
        { text: "EcoBankTanzania", value: 55 },
        { text: "EcobankZambia", value: 56 },
        { text: "QuantumAhadu", value: 57 },
        { text: "QuantumLion", value: 58 },
        { text: "TeleBirrUSSD", value: 59 },
        { text: "Tsedey", value: 60 },
        { text: "Sinke", value: 61 },
        { text: "CBENewMobileBanking", value: 62 },
        { text: "AddisBank", value: 63 },
        { text: "WaafiPaySomalia", value: 64 },
        { text: "Enat", value: 65 },
        { text: "WaafiPayDjibouti", value: 66 },
      ],
      refundPathOptions: [
        { text: "Auto", value: 1 },
        { text: "Manual", value: 2 },
      ],
    };
  },
  computed: {
    rows() {
      return this.paymentOptions.length;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    isLetterandNumber(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[a-zA-Z0-9_.,\s]*$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[a-zA-Z\s]*$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    getByCountry() {
      this.isLoading = true;
      (this.currencyOptions = [{ value: null, text: "--select a Currency--" }]),
        axios
          .get("/Country/api/V1.0/Country/GetAll")
          .then((res) => {
            console.log(this.newPaymentOption);
            res.countries.filter((f) => {
              if (
                f.id == this.newPaymentOption.countryId.value ||
                f.id == this.editPaymentOption.countryId
              ) {
                f.currencies.forEach((item) => {
                  this.currencyOptions.push({
                    value: item.id,
                    text: item.currencyName,
                  });
                });
              }
            });
            this.isLoading = false;
          })
          .catch((err) => {
            console.log(err);
            this.isLoading = false;
          });
    },
    editFop(id) {
      // const editFopItem = this.paymentOptions.filter(i => i.id === id)[0]
      this.editPaymentOption = [];

      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "AllFOP-View");
      axios
        .get(
          `/PaymentOptions/api/V1.0/PaymentOptions/GetPaymentOption?id=${id}`
        )
        .then((res) => {
          (this.currencyOptions = [
            { value: null, text: "--select a Currency--" },
          ]),
            axios
              .get("/Country/api/V1.0/Country/GetAll")
              .then((res) => {
                res.countries.filter((f) => {
                  if (f.id == this.editPaymentOption.countryId) {
                    f.currencies.forEach((item) => {
                      this.currencyOptions.push({
                        value: item.id,
                        text: item.currencyName,
                      });
                    });
                  }
                });
                this.isLoading = false;
              })
              .catch((err) => {
                console.log(err);
                this.isLoading = false;
              });

          this.editPaymentOption = res.paymentOption;
          console.log(this.editPaymentOption);

          this.$bvModal.show("modal-edit-paymentoption");

          this.isLoading = false;

          if (this.editPaymentOption.refundPath === 2) {
            this.isManualOptionEditSelected = true;
            this.isAuthoEditBools = false;
          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    EnablePaymentOption(id, name) {
      this.$bvModal
        .msgBoxConfirm(`Are you sure to Enable  ${name}`, {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "primary",
          headerBgVariant: "success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          this.boolValue = value;
        });
    },
    DeletePaymentOption(id, name) {
      this.$bvModal
        .msgBoxConfirm(`Are you sure to Delete  ${name}`, {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          headerBgVariant: "warning",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.isLoading = true;
            axios
              .delete(
                `/PaymentOptions/api/V1.0/PaymentOptions/DeletePaymentOption?id=${id}`
              )
              .then((res) => {
                this.isLoading = false;
                this.$bvModal
                  .msgBoxOk(`${res.message}`, {
                    title: "Success",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "success",
                    headerClass: "p-2 border-bottom-0",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                  })
                  .then((res) => {
                    window.location.reload();
                  });
              })
              .catch((res) => {
                this.isLoading = false;
                this.$bvModal.msgBoxOk(`${res.data.message}`, {
                  title: "Success",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                });
              });
          }
        });
    },
    redirectto(id) {
      this.boolValue = id;
      this.$router.push("dashboard-ecommerce");
    },
    // API
    fetchData() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "AllFOP-View");
      axios
        .get("/PaymentOptions/api/V1.0/PaymentOptions/GetAllPaymentOptions")
        .then((res) => {
          this.paymentOptions = res.paymentOptions;
          axios
            .get("/PaymentType/api/V1.0/PaymentType/GetAll")
            .then((res) => {
              res.paymentTypes.forEach((item) => {
                this.paymentType.push({
                  value: item.id,
                  text: item.name,
                });
              });
            })
            .catch((err) => {
              console.log(err);
              this.isLoading = false;
            });

          this.$store.dispatch("config/getActionPrivilege", "Provider-View");
          axios
            .get("/Provider/api/V1.0/Provider/GetAll")
            .then((res) => {
              res.providers.forEach((item) => {
                this.providerOptions.push({
                  value: item.id,
                  text: item.providerName,
                });
              });
            })
            .catch((err) => {
              console.log(err);
              this.isLoading = false;
            });
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
      axios
        .get("/Country/api/V1.0/Country/GetAll")
        .then((res) => {
          res.countries.forEach((item) => {
            this.countryOptions.push({
              value: item.id,
              text: item.countryName,
            });
          });
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },
    validationForm() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          this.$refs.modal.hide();
          this.isLoading = true;
          this.newPaymentOption.countryId =
            this.newPaymentOption.countryId.value;
          console.log(this.newPaymentOption);
          const formData = new FormData();
          Object.keys(this.newPaymentOption).forEach((key) => {
            const value = this.newPaymentOption[key];
            formData.append(key, value);
          });
          axios
            .post(
              "/PaymentOptions/api/V1.0/PaymentOptions/AddPaymentOption",
              formData,
              {
                headers: {
                  "Content-Type":
                    "multipart/form-data; boundary=<calculated when request is sent>",
                  Accept: "application/javascript",
                },
              }
            )
            .then((res) => {
              this.isLoading = false;
              this.$bvModal
                .msgBoxOk(`${res.message}`, {
                  title: "Success",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                })
                .then((res) => {
                  window.location.reload();
                });
            })
            .catch((res) => {
              console.log(res);
              this.isLoading = false;
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Error",
                  icon: "BellIcon",
                  variant: "danger",
                  text: `${res.data.title}`,
                },
              });
            });
        }
      });
    },
    validationEditForm() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          this.$refs.modal.hide();
          this.isLoading = true;
          const formData = new FormData();
          Object.keys(this.editPaymentOption).forEach((key) => {
            const value = this.editPaymentOption[key];
            formData.append(key, value);
          });
          axios
            .put(
              "/PaymentOptions/api/V1.0/PaymentOptions/UpdatePaymentOption",
              formData,
              {
                headers: {
                  "Content-Type":
                    "multipart/form-data; boundary=<calculated when request is sent>",
                  Accept: "application/javascript",
                },
              }
            )
            .then((res) => {
              this.isLoading = false;
              this.fetchData();
              this.$bvModal.msgBoxOk(`${res.message}`, {
                title: "Success",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true,
              });
            })
            .catch((res) => {
              console.log(res);
              this.isLoading = false;
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Error",
                  icon: "BellIcon",
                  variant: "danger",
                  text: `${res.data.title}`,
                },
              });
            });
        }
      });
    },
    ChangePaymentOptionExpiry(id, name) {
      this.selectedFop = name;
      this.$bvModal.show("modal-change-expiry");
    },
    ChangePath() {
      if (this.newPaymentOption.refundPath === 2) {
        this.isManualOptionSelected = true;
        this.isAuthoBools = false;
        this.newPaymentOption.refundManualOption = 1;
      } else {
        this.isManualOptionSelected = false;
        this.newPaymentOption.refundManualOption = 0;

        this.isAuthoBools = true;
      }
    },
    ChangeEditPath() {
      if (this.editPaymentOption.refundPath === 2) {
        this.isManualOptionEditSelected = true;
        this.isAuthoEditBools = false;
        this.editPaymentOption.refundManualOption = 1;
      } else {
        this.isManualOptionEditSelected = false;
        this.editPaymentOption.refundManualOption = 0;
        this.isAuthoEditBools = true;
      }
    },
    CheckAuthoRefund() {
      if (this.newPaymentOption.sendAuthRefund) {
        this.newPaymentOption.considerAuthRefundAsConfirmed = false;
      }
    },
    CheckAuthoEditRefund() {
      if (this.editPaymentOption.sendAuthRefund) {
        this.editPaymentOption.considerAuthRefundAsConfirmed = false;
      }
    },
  },
};
</script>
